import axios from 'axios';

const state = {
}
const mutations = {
}
const actions = {
  getDisciplineList({ commit }) {
    return axios.get(`${process.env.VUE_APP_API}/discipline`)
  },
  createDiscipline({ commit }, params) {
    return axios.post(`${process.env.VUE_APP_API}/discipline`, params);
  },
  updateDiscipline({ commit }, params) {
    return axios.put(`${process.env.VUE_APP_API}/discipline`, params);
  },
  disableDiscipline({ commit }, params) {
    return axios.delete(`${process.env.VUE_APP_API}/discipline`, {data:params});
  },
  deleteDiscipline({ commit }, params) {
    return axios.delete(`${process.env.VUE_APP_API}/discipline`, {data:params});
  }
}
const getters = {}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}